var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#214FA8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.828 32V21.072h3.618l.545-4.279h-4.163v-2.732c0-1.236.338-2.076 2.082-2.076h2.205V8.168c-.38-.05-1.702-.168-3.23-.168-3.205 0-5.395 1.984-5.395 5.64v3.153h-3.61v4.279h3.61V32h4.338z",
  fill: "#fff"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMyMTRGQTgiLz4KPHBhdGggZD0iTTIxLjgyNzYgMzJWMjEuMDcxOEgyNS40NDYxTDI1Ljk5MTQgMTYuNzkzSDIxLjgyNzZWMTQuMDYwOUMyMS44Mjc2IDEyLjgyNTIgMjIuMTY2MyAxMS45ODQ2IDIzLjkwOTUgMTEuOTg0NkgyNi4xMTUzVjguMTY4MTNDMjUuNzM1MyA4LjExNzY5IDI0LjQxMzQgOCAyMi44ODUgOEMxOS42Nzk2IDggMTcuNDkwMyA5Ljk4Mzg5IDE3LjQ5MDMgMTMuNjQwNlYxNi43OTNIMTMuODhWMjEuMDcxOEgxNy40OTAzVjMySDIxLjgyNzZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };